<template>
    <div class="container-fluid dashboard-2 pt-2">
        <div class="row general-widget">
            <Card1 colClass="col-sm-6 col-xl-4 box-col-6" cardClass="card widget-1" v-for="(item, index) in widgets"
                :key="index">
                <div class="widget-content">
                    <div class="widget-round " :class="item.class">
                        <div class="bg-round">
                            <svg class="svg-fill">

                                <use :xlink:href="`/icon-sprite.svg#${item.svg1}`">
                                </use>
                            </svg>
                            <svg class="half-circle svg-fill">
                                <use :xlink:href="`/icon-sprite.svg#${item.svg2}`">
                                </use>
                            </svg>
                        </div>
                    </div>
                    <div>
                        <h4>{{ item.number }}</h4><span class="f-light">{{ item.title }}</span>
                    </div>
                </div>
            </Card1>
        </div>
        <div class="card">
            <div class="card-body">
                <DataTable :headers="headers" :items="salesOrders as any" :loading="loading" :total="total" :params="params"
                    @update:params="updateParams">
                    <template #item.transaction_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        formatDateTime(item.transaction_date) }}</template>
                    <template #item.divisi="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        item.divisi_team.name }}</template>
                    <template #item.customer="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        item.customer.name }}</template>
                    <template #item.qty_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        item.qty_total }}</template>
                    <template #item.grand_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        formatCurrency(item.grand_total) }}</template>
                    <template #item.actions="{ item }">
                        <button v-if="item.order_status === 'PENDING'" class="btn btn-sm btn-warning me-2"
                            @click="statusSalesOrder(item as any)">
                            <i class="fa fa-solid fa-right-to-bracket" alt="approved"></i>
                        </button>
                        <button v-if="item.order_status === 'APPROVED'" class="btn btn-sm btn-danger"
                            @click="statusSalesOrder(item as any)">
                            <i class="fa fa-solid fa-xmark"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <!-- Bootstrap Modal for Add/Edit -->
    <div class="modal fade" id="orderModal" tabindex="-1" ref="modalRef">
        <div class="modal-dialog modal-lg"> <!-- {{ Make modal larger for more fields }} -->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalTitle }}</h5>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <!-- <form @submit.prevent="saveOrder"> -->
                <div class="modal-body col-12">
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Order Code</label>
                            <input v-model="form.code" type="text" class="form-control" disabled>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Transaction Date</label>
                            <input v-model="form.transaction_date" class="form-control" type="datetime-local">
                        </div>
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Customer</label>
                        <input v-if="form.customer" v-model="form.customer.name" type="text" class="form-control"
                            disabled>
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Customer Address</label>
                        <textarea v-if="form.customer" v-model="form.customer.address" rows="3" class="form-control"
                            disabled />
                    </div>
                    <div class="mt-4" style="overflow-y: auto;">
                        <h6>Order Items</h6>
                        <table class="table table-sm" v-if="form.ID && form.order_details.length > 0">
                            <thead>
                                <tr>
                                    <th>Produk</th>
                                    <th style="text-align:end">Qty</th>
                                    <th style="text-align:end">Harga</th>
                                    <th style="text-align:end">Diskon</th>
                                    <th style="text-align:end">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in form.order_details" :key="item.productId">
                                    <td>{{ item.name }}</td>
                                    <td style="text-align:end">{{ formatSeparator(item.quantity) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.price) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.discount) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.total) }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="text-align:start; border: 0;"> <label v-if="form?.bank">
                                            Payment
                                            to : {{ form.bank.name }} - {{ form.bank_account?.accountNumber }}/{{
                                            form.bank_account?.accountName }}</label></td>
                                    <td colspan="2" style="text-align:end; border: 0;">Shipping Cost</td>
                                    <td style="text-align:end; border: 0;">{{ formatCurrency(form.shipping_cost) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align:start; border: 0;">Sales : {{ form.sales_name }}</td>
                                    <td colspan="3" style="text-align:end; border: 0;">Other Fee</td>
                                    <td style="text-align:end; border: 0;">{{ formatCurrency(form.fee_amount) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align:start; border: 0;">Admin : {{ session.getUser().name }}</td>
                                    <td colspan="3" style="text-align:end; border: 0;">Grand Total</td>
                                    <td style="text-align:end; border: 0;"><b>{{ formatCurrency(form.grand_total) }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-else>No items found for this order.</p>
                    </div>
                    <div class="row">
                        <div class="row col-md-6">
                            <div class="mb-2">
                                <label class="form-label col-form-label">Order Status</label>
                                <select class="form-select" v-model="form.order_status">
                                    <option v-if="form.order_status == 'PENDING' || form.order_status == 'APPROVED'" value="PENDING">Pending</option>
                                    <option value="APPROVED">Approved</option>
                                    <option value="REJECTED">Rejected</option>
                                    <option value="CANCELLED">Cancelled</option>
                                </select>
                            </div>
                            <div class="mb-2">
                                <label class="form-label col-form-label">Note</label>
                                <textarea v-model="form.order_status_notes" col="3" class="form-control" />
                            </div>
                        </div>

                        <div class="row col-md-5">
                            <div class="mb-2">
                                <div v-if="form.payment_image" class="mt-2">
                                    <img :src="form.payment_image" alt="Preview"
                                        style="max-width: 300px; max-height: 300px;" @click="toggleZoom"
                                        :class="{ 'zoomed': isZoomed }">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" @click="closeModal">Cancel</button>
                    <button type="submit" class="btn btn-warning" :disabled="paymentLoading" @click="processOrder">Process</button>
                </div>
                <!-- </form> -->
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, defineAsyncComponent } from 'vue'
import { toast } from 'vue3-toastify'
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { Modal } from 'bootstrap'
import * as sales from '@/api/services/SalesRequest'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
// {{ Define SalesOrder interface }}
interface SalesOrder {
    id: number | null; // Allow null for new salesOrders
    code: string;
    name: string;
}
const widgets = [
    {
        class: "danger",
        svg1: "cart",
        svg2: "halfcircle",
        number: "10,000",
        title: "Menunggu Terapi",
        font: "font-danger",
        icon: "icon-arrow-up",
        total: "+50%"
    },
    {
        class: "primary",
        svg1: "tag",
        svg2: "halfcircle",
        number: "4,200",
        title: "Sedang Terapi",
        font: "font-primary",
        icon: "icon-arrow-up",
        total: "+70%"
    },
    {
        class: "success",
        svg1: "rate",
        svg2: "halfcircle",
        number: "5700",
        title: "Selesai terapi",
        font: "font-success",
        icon: "icon-arrow-up",
        total: "+70%"
    }
]

const headers = [
    { text: 'Order No', value: 'code' },
    { text: 'Transaction Date', value: 'transaction_date' },
    { text: 'Customer', value: 'customer' },
    { text: 'Payment', value: 'payment' },
    { text: 'Order Status', value: 'order_status' },
    { text: 'QTY', value: 'qty_total' },
    { text: 'Grand Total', value: 'grand_total' },
    { text: '#Act', value: 'actions' }
]
let form = reactive({
    ID: null,
    code: null,
    divisi: null as any | null,
    divisi_team: null as any | null,
    transaction_date: null as Date | null,
    customer: null as any | null,
    order_details: [] as any[],
    shipping: null as any | null,
    courier: null as any | null,
    courier_name: '',
    bank: null as any | null,
    bank_account: null as any | null,
    payment: 'TRANSFER',
    payment_image: null as any | null,
    shipping_cost: 0 as number,
    qty_total: 0 as number,
    sub_total: 0 as number,
    fee_amount: 0 as number,
    grand_total: 0 as number,
    order_status: null as string | null,
    order_status_by: null as string | null,
    order_status_notes: null as string | null,
    sales_email: null as string | null,
    sales_name: null as string | null,
    sales: null as any | null,
    approval_by: null as any | null,
    approval_date: null as any | null,
    approval_notes: null as any | null,
    reject_by: null as any | null,
    reject_date: null as any | null,
    reject_notes: null as any | null,
    cancel_by: null as any | null,
    cancel_date: null as any | null,
    cancel_notes: null as any | null,
});

// {{ Apply types to refs and reactive objects }}
const salesOrders = ref<SalesOrder[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: ''
})

const modalTitle = ref('')

const fetchSalesOrders = async () => {
    loading.value = true
    try {
        // Simulate API delay
        await sales.postRequest("/sales-order/list", { page: params.page, size: params.size, search: params.search }).then((response) => {
            salesOrders.value = response.data;
            total.value = response.total
        });

    } catch (error) {
        toast.error('Failed to fetch salesOrders')
    }
    loading.value = false
}

// {{ Add type annotation for newParams }}
const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchSalesOrders()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

onMounted(() => {
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value)
    }
    fetchSalesOrders() // Fetch salesOrders on mount
})

let paymentLoading = ref(false)
async function processOrder() {
    paymentLoading.value = true
    const dates = form.transaction_date ? new Date(form.transaction_date).toISOString() : new Date().toISOString();
    if (form.order_status == "APPROVED") {
        await sales.postRequest("/sales-order/update-payment", {
            ID: form.ID,
            transaction_date: dates,
            order_status: form.order_status,
            approval_by: session.getUser().name,
            approval_date: new Date(),
            approval_notes: form.order_status_notes,
        })
    } else if (form.order_status == "REJECTED") {
        await sales.postRequest("/sales-order/update-payment", {
            ID: form.ID,
            transaction_date: dates,
            order_status: form.order_status,
            reject_by: session.getUser().name,
            reject_date: new Date(),
            reject_notes: form.order_status_notes,
        })
    } else if (form.order_status == "CANCELLED") {
        await sales.postRequest("/sales-order/update-payment", {
            ID: form.ID,
            transaction_date: dates,
            order_status: form.order_status,
            cancel_by: session.getUser().name,
            cancel_date: new Date(),
            cancel_notes: form.order_status_notes,
        })
    }else{
        await sales.postRequest("/sales-order/update-payment", {
            ID: form.ID,
            transaction_date: dates,
            order_status: form.order_status
        })
    }
    paymentLoading.value = false
    closeModal()
    fetchSalesOrders()
}

// {{ Add type annotation for salesOrder parameter }}
const openModal = (salesOrder: SalesOrder | null = null) => {
    paymentLoading.value = false
    if (salesOrder) {
        modalTitle.value = 'Sales Order'
        Object.assign(form, salesOrder);
        form.transaction_date = (salesOrder as any).transaction_date ? new Date((salesOrder as any).transaction_date) : null;
    }
    if (bsModal) { // Check if bsModal is initialized
        bsModal.show()
    }
}

function formatDate(date: any) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
const closeModal = () => {
    if (bsModal) { // Check if bsModal is initialized
        bsModal.hide()
    }
}
// {{ Define statusSalesOrder function }}
const statusSalesOrder = (salesOrder: SalesOrder) => {
    openModal(salesOrder); // Call openModal with the salesOrder data
}

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}
function formatCurrency(value: number) {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value);
}

function formatSeparator(value: number): string {
    return new Intl.NumberFormat('id-ID', {
        style: 'decimal',
        minimumFractionDigits: 0
    }).format(value);
}

const isZoomed = ref(false);

const toggleZoom = () => {
    isZoomed.value = !isZoomed.value;
};
// Initial fetch is now called in onMounted
</script>

<style scoped>
.zoomed {
    transform: scale(2);
    transition: transform 0.3s ease;
}
</style>